import React from 'react';
import { connect } from "react-redux";
import HttpAPICall from "../../services/HttpAPICall";
import Loader from "../../components/ui/Loader/Loader"
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Status from '../../components/ui/Status';
import { INVENTORY_API_BASE_URL_2 } from '../../services/TapApiUrls';
import Ax from '../../components/hoc/Ax';

class ItemAdditionalAttributes extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            item_id: props.item_enc_id || null,
            refreshDetail: props.refreshDetail || false,
            additionalAttr: [],
            details_loading: false
        }
        this.itemAdditionalAttrUrl = INVENTORY_API_BASE_URL_2 + "/item/additional_attr";
    }

    componentDidMount() {
        if (this.props.item_enc_id) {
            this.getItemDetails(this.props.item_enc_id);
        }
    }

    componentDidUpdate(prevProps) {
    // Case 1: Item ID changed - definitely need to fetch new data
    if (prevProps.item_enc_id !== this.props.item_enc_id) {
        this.setState(
            {
                item_id: this.props.item_enc_id,
                refreshDetail: false, // Reset the refresh flag
                additionalAttr: [] // Clear old data
            },
            () => {
                this.getItemDetails(this.props.item_enc_id);
            }
        );
    }
    // Case 2: Refresh requested AND we're not already loading
    else if (
        this.props.refreshDetail === true && 
        prevProps.refreshDetail !== this.props.refreshDetail &&
        !this.state.details_loading
    ) {
        // Store the fact that we're refreshing
        this.setState({ details_loading: true }, () => {
            this.getItemDetails(this.props.item_enc_id);
        });
    }
}

    // componentDidUpdate(prevProps) {
    //     if (prevProps.item_enc_id !== this.props.item_enc_id || 
    //         this.props.refreshDetail === true) {
    //         this.setState({ 
    //             item_id: this.props.item_enc_id, 
    //             refreshDetail: this.props.refreshDetail 
    //         }, () => {
    //             this.getItemDetails(this.props.item_enc_id);
    //         });
    //     }
    // }

    // Remove or conditionally use routing
    changeTab = (key) => {
        // Only use routing if history and location exist (not in modal)
        if (this.props.history && this.props.location) {
            let ParamObject = new URLSearchParams(this.props.location.search);
            let itemName, itemCategory;
            if (ParamObject.get('item_name')) {
                itemName = ParamObject.get('item_name');
            }
            if (ParamObject.get('item_category')) {
                itemCategory = ParamObject.get('item_category');
            }
            let obj = { item_name: itemName, item_category: itemCategory };
            this.props.history.push({ 
                pathname: `/item_list/${key}/${this.state.item_id}`, 
                search: "?" + new URLSearchParams(obj).toString() 
            });
        }
    }

    getItemDetails = (id) => {
    if (!id) return;
    
    this.setState({ details_loading: true });
    
    HttpAPICall.withAthorization(
        'GET', 
        this.itemAdditionalAttrUrl + '/' + id, 
        this.props.access_token, 
        {}, 
        {}, 
        (resp) => {
            this.setState({ additionalAttr: resp.data || [] });
            
            // IMPORTANT: Notify parent that refresh is complete
            if (this.props.onRefreshComplete) {
                this.props.onRefreshComplete();
            }
        }
    ).finally(() => { 
        this.setState({ details_loading: false });
    });
}

    // getItemDetails = (id) => {
    //     if (!id) return;
        
    //     this.setState({ details_loading: true });
    //     HttpAPICall.withAthorization(
    //         'GET', 
    //         this.itemAdditionalAttrUrl + '/' + id, 
    //         this.props.access_token, 
    //         {}, 
    //         {}, 
    //         (resp) => {
    //             this.setState({ additionalAttr: resp.data || [] });
    //         }
    //     ).finally(() => { 
    //         this.setState({ details_loading: false });
    //     });
    // }

    render() {
        const { additionalAttr, details_loading } = this.state;
        const { hideHelmet } = this.props;

        return (
            <section className="item_view_container bg-white">
                {!hideHelmet && <Helmet><title>Item Additional Attributes</title></Helmet>}
                
                {details_loading ? (
                    <Loader />
                ) : (
                    <div className="tab_content_header">
                        {additionalAttr && additionalAttr.length > 0 ? (
                            <div>
                                <div className="tab_content_wrapper">
                                    <div>
                                        <span className="content_heading">Additional Attribute</span>
                                    </div>
                                </div>
                                <table className="table table-hover table-borderless">
                                    <tbody>
                                        {additionalAttr.map((a, k) => (
                                            <tr key={k}>
                                                <td className="details-label text-capitalize" style={{ width: "34%" }}>
                                                    {a.name}
                                                </td>
                                                <td className="details-name" style={{ width: "66%" }}>
                                                    {a.value || "-"}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="text-center p-4">
                                <p className="text-muted">No additional attributes found for this item.</p>
                            </div>
                        )}
                    </div>
                )}
            </section>
        );
    }
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token,
        isc_configuration: state.app && state.app.isc_configuration ? state.app.isc_configuration : null,
    };
};

export default connect(mapStateToProps)(ItemAdditionalAttributes);


